(() => {
  if (window.collectionQuickViewYmqBridgeLoaded) return;
  window.collectionQuickViewYmqBridgeLoaded = true;

  const ensureQuickViewSwatchLinks = (quickViewModal) => {
    quickViewModal
      .querySelectorAll('.swatch-group-selector[swatch-url]')
      .forEach((swatch) => {
        const swatchItem = swatch.matches('.swatch-drop-down-list-item')
          ? swatch
          : swatch.closest('.swatch-view-item');
        const existingLink = swatchItem?.querySelector(
          ':scope > .collection-quick-view__swatch-link'
        );

        if (!swatchItem || swatch.hasAttribute('current-product')) {
          existingLink?.remove();
          return;
        }

        const swatchUrl = swatch.getAttribute('swatch-url');
        if (!swatchUrl) return;

        const label = swatchItem.getAttribute('aria-label') || swatch.dataset.value || 'product';
        const link = existingLink || document.createElement('a');
        link.href = new URL(swatchUrl, window.location.origin).href;
        link.target = '_blank';
        link.rel = 'noopener noreferrer';
        link.setAttribute('aria-label', `Open ${label} in a new tab`);
        link.title = `Open ${label} in a new tab`;

        if (!existingLink) {
          link.className = 'collection-quick-view__swatch-link';
          link.addEventListener('click', (event) => event.stopPropagation());
          swatchItem.appendChild(link);
        }
      });
  };

  const setupDetailsToggles = (details) => {
    details.querySelectorAll('.parameter_block > .title, .Details_block > .title').forEach((title) => {
      if (title.dataset.quickViewToggleReady === 'true') return;
      title.dataset.quickViewToggleReady = 'true';
      title.setAttribute('role', 'button');
      title.setAttribute('tabindex', '0');
      title.setAttribute('aria-expanded', 'true');

      const toggle = () => {
        const block = title.parentElement;
        const isCollapsed = block.classList.toggle('art');
        title.setAttribute('aria-expanded', String(!isCollapsed));
      };

      title.addEventListener('click', toggle);
      title.addEventListener('keydown', (event) => {
        if (event.key !== 'Enter' && event.key !== ' ') return;
        event.preventDefault();
        toggle();
      });
    });
  };

  const loadProductDetails = async (details) => {
    if (details.dataset.detailsState) return;
    details.dataset.detailsState = 'loading';

    try {
      const response = await fetch(details.dataset.productUrl, {
        credentials: 'same-origin',
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
      });
      if (!response.ok) throw new Error(`Product details request failed: ${response.status}`);

      const productDocument = new DOMParser().parseFromString(await response.text(), 'text/html');
      const source = productDocument.querySelector('.parameter_model .centent');
      if (!source) throw new Error('Product details are not available');

      const importedDetails = source.cloneNode(true);
      importedDetails.classList.remove('page-width');
      importedDetails.querySelectorAll('script, style').forEach((element) => element.remove());
      importedDetails.querySelectorAll('.parameter_block .item').forEach((item) => {
        const value = item.querySelector('.value')?.textContent.trim();
        if (!value) item.remove();
      });

      const specifications = importedDetails.querySelector('.parameter_block');
      const description = importedDetails.querySelector('.Details_block');
      const hasSpecifications = !!specifications?.querySelector('.item, .item_pdf');

      if (specifications && !hasSpecifications) specifications.remove();
      description?.remove();
      if (!importedDetails.querySelector('.parameter_block')) throw new Error('Product specifications are empty');

      const specificationsBox = specifications?.querySelector('.box');
      const installationLink = specifications?.querySelector('.item_pdf');
      if (specificationsBox && installationLink) specificationsBox.prepend(installationLink);

      details.replaceChildren(importedDetails);
      details.dataset.detailsState = 'loaded';
      setupDetailsToggles(details);
    } catch (error) {
      details.hidden = true;
      details.dataset.detailsState = 'unavailable';
    }
  };

  const positionProductDetails = (quickViewModal, details) => {
    const productInfo = quickViewModal.querySelector(
      '.quick-add-modal__content-info .product__info-container'
    );
    if (!productInfo || !details) return;

    const optionsAnchor =
      productInfo.querySelector('[id*="picture_it_live"]') ||
      productInfo.querySelector('[id*="swatch_king"]') ||
      productInfo.querySelector('variant-king-combined-listing') ||
      productInfo.querySelector('.product-form__input');

    if (optionsAnchor) {
      if (details.parentElement !== productInfo || details.nextElementSibling !== optionsAnchor) {
        productInfo.insertBefore(details, optionsAnchor);
      }
      return;
    }

    if (details.parentElement !== productInfo) {
      const priceBlock = productInfo.querySelector('[id^="price-"]');
      if (priceBlock) {
        priceBlock.after(details);
      } else {
        productInfo.appendChild(details);
      }
    }
  };

  const ensureProductDetails = (quickViewModal) => {
    const contentInfo = quickViewModal.querySelector('.quick-add-modal__content-info');
    const product = contentInfo?.querySelector('.product');
    const detailsTemplate = quickViewModal.querySelector('[data-collection-quick-view-details-template]');
    if (!product || !detailsTemplate) return;

    let details = product.querySelector('.collection-quick-view__product-details');
    if (!details) {
      const detailsFragment = detailsTemplate.content.cloneNode(true);
      details = detailsFragment.querySelector('.collection-quick-view__product-details');
      if (!details) return;
      product.appendChild(detailsFragment);
    }

    positionProductDetails(quickViewModal, details);
    loadProductDetails(details);
  };

  const syncFooterButton = (quickViewModal) => {
    const footerButton = quickViewModal.querySelector('[data-collection-quick-view-add]');
    const footerLabel = quickViewModal.querySelector('[data-collection-quick-view-add-label]');
    const contentInfo = quickViewModal.querySelector('.quick-add-modal__content-info');
    const productInfo = contentInfo?.querySelector('product-info');
    const productButton = contentInfo?.querySelector('button[name="add"]');

    if (!footerButton || !footerLabel) return;

    if (productInfo && productInfo.dataset.quickViewScrollReady !== 'true') {
      productInfo.dataset.quickViewScrollReady = 'true';
      window.requestAnimationFrame(() => {
        contentInfo.scrollTop = 0;
      });
    }

    if (!productButton) {
      footerButton.disabled = true;
      footerLabel.textContent = 'Add to Cart';
      return;
    }

    const isLoading = productButton.classList.contains('loading');
    const isDisabled =
      productButton.disabled || productButton.getAttribute('aria-disabled') === 'true' || isLoading;
    const productButtonText = productButton.textContent.replace(/\s+/g, ' ').trim();

    footerButton.disabled = isDisabled;
    footerButton.classList.toggle('loading', isLoading);
    footerLabel.textContent = isLoading ? 'Adding…' : productButtonText || 'Add to Cart';
  };

  const setupQuickViewModal = (quickViewModal) => {
    if (!quickViewModal || quickViewModal.dataset.footerBridgeReady === 'true') return;

    const contentInfo = quickViewModal.querySelector('.quick-add-modal__content-info');
    if (!contentInfo) return;

    quickViewModal.dataset.footerBridgeReady = 'true';

    const footerObserver = new MutationObserver(() => {
      ensureQuickViewSwatchLinks(quickViewModal);
      ensureProductDetails(quickViewModal);
      syncFooterButton(quickViewModal);
    });
    footerObserver.observe(contentInfo, {
      attributes: true,
      attributeFilter: ['class', 'disabled', 'aria-disabled'],
      childList: true,
      characterData: true,
      subtree: true,
    });

    ensureQuickViewSwatchLinks(quickViewModal);
    ensureProductDetails(quickViewModal);
    syncFooterButton(quickViewModal);
  };

  const prefetchQuickViewProduct = (event) => {
    const productCard = event.target.closest('.product-card-wrapper');
    const quickViewButton =
      event.target.closest('.collection-quick-view__button') ||
      productCard?.querySelector('.collection-quick-view__button');
    const productUrl = quickViewButton?.getAttribute('data-product-url');

    if (productUrl && typeof window.prefetchQuickAddProductHTML === 'function') {
      window.prefetchQuickAddProductHTML(productUrl);
    }
  };

  document.addEventListener('pointerover', prefetchQuickViewProduct, true);
  document.addEventListener('focusin', prefetchQuickViewProduct, true);
  document.addEventListener('touchstart', prefetchQuickViewProduct, {
    capture: true,
    passive: true,
  });

  document.addEventListener(
    'click',
    (event) => {
      const openerButton = event.target.closest('.collection-quick-view__button');
      if (openerButton) {
        const modalSelector = openerButton.closest('modal-opener')?.dataset.modal;
        const quickViewModal = modalSelector ? document.querySelector(modalSelector) : null;
        const contentInfo = quickViewModal?.querySelector('.quick-add-modal__content-info');
        if (contentInfo) contentInfo.scrollTop = 0;
        setupQuickViewModal(quickViewModal);
        return;
      }

      const footerButton = event.target.closest('[data-collection-quick-view-add]');
      if (footerButton) {
        const quickViewModal = footerButton.closest('.collection-quick-view__modal');
        const productButton = quickViewModal?.querySelector(
          '.quick-add-modal__content-info button[name="add"]'
        );

        if (!productButton || footerButton.disabled) return;
        productButton.click();
        window.requestAnimationFrame(() => syncFooterButton(quickViewModal));
        return;
      }

      const addButton = event.target.closest('.collection-quick-view__modal button[name="add"]');
      if (!addButton) return;

      const quickViewModal = addButton.closest('quick-add-modal');
      if (!quickViewModal) return;

      let timeoutId;
      const observer = new MutationObserver(() => {
        const ymqDrawer = document.querySelector('#ymq-cart-app.opened');
        if (!ymqDrawer) return;

        observer.disconnect();
        window.clearTimeout(timeoutId);

        if (quickViewModal.hasAttribute('open') && typeof quickViewModal.hide === 'function') {
          quickViewModal.hide(true);
        }
      });

      observer.observe(document.body, {
        attributes: true,
        attributeFilter: ['class'],
        childList: true,
        subtree: true,
      });

      timeoutId = window.setTimeout(() => observer.disconnect(), 10000);
    },
    true
  );
})();
